module.exports = new __parcel__URL__("Zoldath 2 2024-11-02 2035.69adf1d0.mp3").toString();